import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import Swiper from '../../../../node_modules/swiper/core/core.js';
import '../../../../node_modules/swiper/shared/dom.js';
import Navigation from '../../../../node_modules/swiper/modules/navigation/navigation.js';
import Pagination from '../../../../node_modules/swiper/modules/pagination/pagination.js';
import EffectFade from '../../../../node_modules/swiper/modules/effect-fade/effect-fade.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './image-video-carousel.scss.js';
import css_248z$2 from '../../../styles/global/rich-text.scss.js';
import css_248z$1 from '../../atoms/buttons/generic-button/styles/generic-button.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
const textBlockSelector = 'text-block';
class ImageVideoCarousel extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.nextText = '';
        this.previousText = '';
    }
    adjustSlots() {
        const slidesWrapper = this.shadowRoot.querySelector('.swiper-wrapper');
        const slotsContainer = this.shadowRoot.querySelector('slot[name="slides-container"]');
        slotsContainer.assignedElements().forEach(slot => {
            slidesWrapper.append(slot);
            const headline = slot.querySelector('.slide-header');
            const textBlock = slot.querySelector(textBlockSelector);
            const richText = textBlock === null || textBlock === void 0 ? void 0 : textBlock.querySelector('.rich-text');
            richText === null || richText === void 0 ? void 0 : richText.prepend(headline);
        });
    }
    updated() {
        setTimeout(() => {
            var _a, _b, _c, _d, _e;
            const swiperContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper');
            const nav = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('carousel-dot-navigation');
            this._prevBtn = (_c = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.swiper-button-prev');
            this._nextBtn = (_d = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.swiper-button-next');
            const paginator = (_e = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('.swiper-pagination');
            if (swiperContainer) {
                this.adjustSlots();
                this._swiper = new Swiper(swiperContainer, {
                    modules: [Navigation, Pagination, EffectFade],
                    speed: 500,
                    effect: 'slide',
                    fadeEffect: { crossFade: true },
                    touchEventsTarget: 'wrapper',
                    simulateTouch: true,
                    allowTouchMove: true,
                    loop: true,
                    pagination: {
                        el: paginator,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: this._nextBtn,
                        prevEl: this._prevBtn,
                    },
                    preloadImages: false,
                    lazy: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                });
            }
        }, 0);
    }
    render() {
        var _a;
        return x `<div class="image-video-carousel ${this.rtl || isRTL() ? 'rtl' : ''} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}"><slot name="headline"></slot><div class="swiper"><div class="swiper-wrapper"></div><slot name="slide-header"></slot><slot name="slides-container"></slot></div><carousel-dot-navigation ?rtl="${this.rtl || isRTL() ? 'rtl' : ''}" nextText="${this.nextText}" previousText="${this.previousText}"></carousel-dot-navigation></div>`;
    }
}
ImageVideoCarousel.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
];
__decorate([
    n({ type: Boolean })
], ImageVideoCarousel.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], ImageVideoCarousel.prototype, "nextText", void 0);
__decorate([
    n({ type: String })
], ImageVideoCarousel.prototype, "previousText", void 0);
customElements.define('image-video-carousel', ImageVideoCarousel);

export { ImageVideoCarousel };
